export type DonutChartOptionsProps = {
  formatter: (value: number | null | undefined) => string;
  data: {
    name: string;
    value: number | null | undefined;
    color: string;
  }[];
};

export const donutChartOptions = (
  props: DonutChartOptionsProps
): Highcharts.Options => ({
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  tooltip: {
    pointFormatter() {
      return props.formatter(this.y);
    },
  },
  series: [
    {
      type: 'pie',
      size: '80%',
      innerSize: '60%',
      dataLabels: {
        formatter() {
          return `${this.name}<br />${props.formatter(this.y)}`;
        },
        style: {
          fontWeight: 'normal',
        },
      },
      data: props.data.map(dataItem => ({
        name: dataItem.name,
        y: dataItem.value ?? 0,
        color: dataItem.color,
      })),
    },
  ],
});
